<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{ '--width': widthVar }" class="pageHeader">化学品库存管理</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <el-form-item label="组织结构">
          <OrganDialog ref="organDia1" @getSelect="getSelect1" :level="levell" @handleOrganQuery="handleOrganQuery1">
          </OrganDialog>
          <el-input v-model="organLabel" placeholder="请选择" style="width:320px;" @focus="dialogOpen1"
            @clear="handeleClear1" clearable></el-input>
        </el-form-item>
        <el-form-item label="化学品名称">
          <el-input v-model="formInline.name" clearable placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="CAS号">
          <el-input v-model="formInline.cas_number" clearable placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="化学品分类">
          <el-select v-model="formInline.category" clearable placeholder="请选择">
            <el-option v-for="item in $store.state.chemicalCates" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <custom-table :data="tableData" border style="width: 100%">
        <custom-table-column fixed label="序号" type="index" width="50">
        </custom-table-column>
        <custom-table-column fixed prop="name" label="化学品名称" min-width="150">
        </custom-table-column>
        <custom-table-column prop="cas_number" label="CAS号" width="120">
        </custom-table-column>
        <custom-table-column prop="" label="所属组织结构" min-width="200">
          <template slot-scope="scope">
            <span>{{ scope.row.structure_1 }}{{ scope.row.structure_2 }}</span>
          </template>
        </custom-table-column>
        <custom-table-column prop="is_over_max_stock" label="存量上限" width="120">
          <template slot-scope="scope">
            <span v-if="scope.row.is_over_max_stock" style="color: var(--red);">{{ scope.row.max_stock }}（已超出）</span>
            <span v-else style="color: var(--ligtGreen);">{{ scope.row.max_stock }}</span>
          </template>
        </custom-table-column>
        <custom-table-column prop="current_stock" label="当前库存" width="120">
        </custom-table-column>
        <custom-table-column prop="unit" label="单位" width="80">
        </custom-table-column>
        <custom-table-column prop="category" label="化学品分类" width="120">
        </custom-table-column>
        <custom-table-column prop="total_value" label="化学品总价/元" width="120">
        </custom-table-column>
        <custom-table-column label="标识" min-width="140">
          <template slot-scope="scope" v-if="scope.row.label">
            <el-image style="width: 80px; height: 80px" v-for="(item, index) in scope.row.label.split(',')" :key="index"
              :src="item" :preview-src-list="scope.row.label.split(',')">
            </el-image>
          </template>
        </custom-table-column>
        <custom-table-column fixed="right" label="操作" width="180">
          <template slot-scope="scope">
            <el-button @click="handleDetailClick(scope.row)" type="text" size="small">查看详情</el-button>
            <el-button @click="handleEditNew(scope.row, ['id'])" type="text" size="small">设置库存上限</el-button>
          </template>
        </custom-table-column>
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" title="详情" :visible.sync="detailDialogVisible" width="946px">
      <div>
        <el-form :inline="true" :model="formInline1" class="demo-form-inline" label-position="left">
          <el-form-item label="化学品编号">
            <el-input v-model="formInline1.item_code" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="formInline1.status" clearable placeholder="请选择">
              <el-option v-for="item in $store.state.useStatus" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="入库开始日期">
            <el-date-picker v-model="formInline1.start_inbound_date" type="date" value-format="yyyy-MM-dd" clearable
              placeholder="选择开始日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="入库结束日期">
            <el-date-picker v-model="formInline1.end_inbound_date" type="date" value-format="yyyy-MM-dd" clearable
              placeholder="选择结束日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleQuery1">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div style="padding: 8px 0;">
        <el-tag v-if="formInline1.name">化学品名称：{{ formInline1.name }}</el-tag>
        <el-tag v-if="formInline1.structure_1">所属组织结构：{{ formInline1.structure_1 }}{{ formInline1.structure_2
        }}</el-tag>
        <el-tag v-if="formInline1.cas_number">CAS号：{{ formInline1.cas_number }}</el-tag>
        <el-tag v-if="formInline1.category">化学品分类：{{ formInline1.category }}</el-tag>
      </div>
      <div>
        <custom-table :data="tableData1" border style="width: 100%">
          <custom-table-column fixed label="序号" type="index" width="50">
          </custom-table-column>
          <custom-table-column prop="item_code" label="化学品编号" width="120">
          </custom-table-column>
          <custom-table-column prop="status" label="状态" width="80" label-class-name="useStatus" :formatter="format_arr">
          </custom-table-column>
          <custom-table-column prop="initial_quantity" width="80" label="入库数量">
          </custom-table-column>
          <custom-table-column prop="current_quantity" width="80" label="当前库存">
          </custom-table-column>
          <custom-table-column prop="inbound.inbound_time" label="入库日期" width="160">
          </custom-table-column>
          <custom-table-column prop="price" width="80" label="总价/元">
          </custom-table-column>
          <custom-table-column prop="inbound.manufacturer" min-width="160" label="厂商">
          </custom-table-column>
          <custom-table-column fixed="right" label="操作" width="120">
            <template slot-scope="scope">
              <!-- <el-button @click="handleDelet1(scope.row.id)" type="text" size="small">删除</el-button> -->
              <el-button @click="detailMethod(scope.row, 'view')" type="text" size="small">查看详情</el-button>
              <el-button v-if="scope.row.status == 1" @click="handleDisposal(scope.row)" type="text"
                size="small">废弃</el-button>
            </template>
          </custom-table-column>
        </custom-table>
        <div class="pageLine">
          <PageLine :total='total1' ref="pageChild1" @getList="getList1"></PageLine>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="detailDialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>

    <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="centerDialogVisible" width="546px">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
        <el-form-item label="库存上限" prop="max_stock">
          <el-input v-model="ruleForm.max_stock" placeholder="请输入" clearable style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" v-if="type == 'edit'"
            @click="submitFormByFun('ruleForm', updateMethod)">设置</el-button>
          <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog :close-on-click-modal="false" title="废弃详情" :visible.sync="centerDialogVisible1" width="546px">
      <el-form :model="ruleForm1" :rules="rules1" ref="ruleForm1" label-width="120px" class="demo-ruleForm">
        <el-form-item label="负责人" prop="disposal_handler_id">
          <el-select v-model="ruleForm1.disposal_handler_id" clearable style="width:360px;" filterable reserve-keyword
            :loading="loading" remote :remote-method="remoteMethod" placeholder="请输入名称搜索" @change="handleUserChange">
            <el-option v-for="item in users" :key="item.id" :label="item.name" :value="item.id">
              <p>{{ item.name }}</p>
              <p v-if="item.number" class="el-option-tips">工号：{{ item.number }}</p>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="废弃地点" prop="disposal_location">
          <el-input v-model="ruleForm1.disposal_location" clearable placeholder="请输入" style="width:360px;"></el-input>
        </el-form-item>
        <el-form-item label="废弃日期" prop="disposal_date">
          <el-date-picker type="date" placeholder="请选择" value-format="yyyy-MM-dd" v-model="ruleForm1.disposal_date"
            style="width:360px;"></el-date-picker>
        </el-form-item>
        <el-form-item label="备注" prop="disposal_notes">
          <el-input type="textarea" v-model="ruleForm1.disposal_notes" placeholder="请输入" style="width:360px;" :rows="4">
          </el-input>
        </el-form-item>
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" @click="submitFormByFun('ruleForm1', updateMethod1)">设置</el-button>
          <el-button @click="resetForm('ruleForm1')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog :close-on-click-modal="false" title="详情" :visible.sync="detailInnerDialogVisible" width="746px">
      <el-descriptions class="margin-top" title="" direction="vertical" :column="3" border>
        <template v-if="rowObj.item">
          <el-descriptions-item>
            <template slot="label">化学品编号 </template> {{ rowObj.item.item_code }}
          </el-descriptions-item>
          <template v-if="rowObj.item.chemical">
            <el-descriptions-item>
              <template slot="label">化学品名称 </template> {{ rowObj.item.chemical.name }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">CAS号 </template> {{ rowObj.item.chemical.cas_number }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">化学品分类 </template> {{ rowObj.item.chemical.category }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">单位 </template> {{ rowObj.item.chemical.unit }}
            </el-descriptions-item>
          </template>
          <el-descriptions-item>
            <template slot="label">入库数量 </template> {{ rowObj.item.initial_quantity }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">当前库存 </template> {{ rowObj.item.current_quantity }}
          </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">总价/元 </template> {{ rowObj.item.price }}
            </el-descriptions-item>
          <template v-if="rowObj.item.inbound">
            <el-descriptions-item>
              <template slot="label">入库时间 </template> {{ rowObj.item.inbound.inbound_time }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">存放地点</template> {{ rowObj.item.inbound.location }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">厂商 </template> {{ rowObj.item.inbound.manufacturer }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">注意事项 </template> {{ rowObj.item.inbound.notes }}
            </el-descriptions-item>
            <el-descriptions-item :span="3">
              <template slot="label">标识 </template>
              <div v-if="rowObj.item.inbound.label">
                <el-image v-for="(img, index) in rowObj.item.inbound.label.split(',')" :key="index"
                  style="width: 100px; height: 100px" :src="img"
                  :preview-src-list="rowObj.item.inbound.label.split(',')">
                </el-image>
              </div>
              <span v-else>无</span>
            </el-descriptions-item>
          </template>
          <el-descriptions-item>
            <template slot="label">状态 </template> {{ $store.state.useStatus[rowObj.item.status - 1].label }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">废弃人 </template> {{ rowObj.item.disposal_handler_name }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">废弃人工号 </template> {{ rowObj.item.disposal_handler_number }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">废弃人地点 </template> {{ rowObj.item.disposal_location }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">备注 </template> {{ rowObj.item.disposal_notes }}
          </el-descriptions-item>
        </template>
      </el-descriptions>
      <p style="font-size: 16px;font-weight: 700;color:#111;margin-top:32px;margin-bottom:20px;">领用记录</p>
      <custom-table :data="rowObj.borrow_records" border style="width: 100%">
        <custom-table-column prop="created_at" label="发放时间">
        </custom-table-column>
        <custom-table-column prop="item_code" label="化学品编号">
        </custom-table-column>
        <custom-table-column prop="quantity" label="领用量">
        </custom-table-column>
        <custom-table-column prop="borrow.username" label="申请人">
        </custom-table-column>
        <custom-table-column prop="borrow.apply_training_room_name" :label="`所属${$store.state.themeTitle}室`">
        </custom-table-column>
        <custom-table-column prop="borrow.purpose" label="用途">
        </custom-table-column>
      </custom-table>
    </el-dialog>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinOrgan } from '@/assets/js/mixin/organization';
import { mixinValidate } from '@/assets/js/mixin/validate';
import { mixinFormatter } from '@/assets/js/mixin/formatter';

export default {
  name: 'equipmentInto',
  mixins: [mixinList, mixinOrgan, mixinValidate, mixinFormatter],
  data() {
    return {
      formInline: {
        category: '',
        name: '',
        cas_number: '',
        structure_1: '',
        structure_2: '',
      },
      ruleForm1: {
        item_id: '',
        disposal_date: '',
        disposal_notes: '',
        disposal_location: '',
        disposal_handler_id: '',
        disposal_handler_name: '',
        disposal_handler_number: '',
      },
      users: [],
      loading: false,
      centerDialogVisible1: false,
      formInline1: {
        id: '',
        status: '',
        item_code: '',
        start_inbound_date: '',
        end_inbound_date: '',
      },
      detailDialogVisible: false,
      detailInnerDialogVisible: false,
      levell: [1, 2],
      organLabel: '',
      eqs: [],
      rowObj: {},
      scraps: [{ isid: '1', ismc: '普通' }],
      total: 40,
      ruleForm: {
        max_stock: '',
      },
      tableData1: [],
      total1: 0,
      listArr: [],
      remainder_quantity: 0,
      rules: {
        max_stock: [{ required: true, message: `请输入`, trigger: 'blur' },
        { validator: this.checkfloat, trigger: 'blur' }],
      },
      rules1: {
        disposal_notes: [{ required: true, message: `请输入`, trigger: 'blur' }],
        disposal_location: [{ required: true, message: `请输入`, trigger: 'blur' }],
        disposal_date: [{ required: true, message: `请选择`, trigger: 'change' }],
        disposal_handler_id: [{ required: true, message: `请选择`, trigger: 'change' }],
      },
    };
  },
  components: {},
  created() { },
  mounted() {
    // this.getStudentApply()
    // this.getProvince()
    // this.$store.dispatch('getTarinMent', { type: 'all' });
  },
  methods: {
    handleSet() {
      this.centerDialogVisible = true;
    },
    handleUserChange(val) {
      const { name, number } = this.$until.getLabelNameNew({ arr: this.users, id: val })
      this.ruleForm1.disposal_handler_name = name;
      this.ruleForm1.disposal_handler_number = number;
    },
    handleDisposal(row) {
      this.ruleForm1 = {
        item_id: row.id,
        disposal_date: '',
        disposal_notes: '',
        disposal_location: '',
        disposal_handler_id: '',
        disposal_handler_name: '',
        disposal_handler_number: '',
      }
      this.centerDialogVisible1 = true;
    },
    async remoteMethod(query, isConcat = false) {
      this.loading = true;
      this.users = [];
      let params = {
        page: 1,
        size: 10,
        name: query,
        type: this.$until.getPostsType([4])
      };
      let res = await this.$api.query.getUsersUnLoad(params);
      if (res.code == 0 && res.data) {
        if (isConcat) {
          this.users = this.users.concat(res.data.data);
        } else {
          this.users = res.data.data;
        }
      }
      this.loading = false;

    },
    handleClick() {
      this.centerDialogVisible = true;
    },
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.instance.interfaceServer('api/chemical/info/list', 'get', params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },

    async getList1() {
      let params = this.$until.deleteNullPrototype(this.formInline1);
      params.page = this.$refs.pageChild1.page;
      params.size = this.$refs.pageChild1.size;
      let res = await this.$api.instance.interfaceServer(`api/chemical/info/items/${params.id}`, 'get', params);
      if (res.code == 0 && res.data) {
        this.tableData1 = res.data.data;
        this.total1 = res.data.total;
      }
    },

    async detailMethod(row, type = "view") {
      let res = await this.$api.instance.interfaceServer(`api/chemical/info/item/${row.id}`, 'get');
      if (res.code == 0 && res.data) {
        this.rowObj = res.data;
        this.detailInnerDialogVisible = true;
      }
    },
    handleDetailClick(row) {
      // this.rowObj = row;
      this.detailDialogVisible = true;
      this.formInline1.id = row.id;
      this.formInline1.structure_1 = row.structure_1
      this.formInline1.structure_2 = row.structure_2
      this.formInline1.name = row.name
      this.formInline1.cas_number = row.cas_number
      this.formInline1.category = row.category
      this.tableData1 = []
      this.handleQuery1()
    }, handleQuery() {
      this.beforeQuery1();
      this.$refs.pageChild.page = 1;
      this.getList();
    },

    handleQuery1() {
      this.$nextTick(() => {
        this.$refs.pageChild1.page = 1;
        this.getList1();
      });
    },
    async updateMethod() {
      let params = this.$until.easyDeepCopy(this.ruleForm);
      let res = await this.$api.instance.interfaceServer(`api/chemical/info/set-max-stock/${params.id}`, 'put', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '设置成功！',
        });
        this.clearState();
      }
    },
    async updateMethod1() {
      let params = this.$until.easyDeepCopy(this.ruleForm1);
      let res = await this.$api.instance.interfaceServer(`api/chemical/disposal/disposal`, 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '设置成功！',
        });
        this.resetForm('ruleForm1')
        this.centerDialogVisible1 = false;
        this.handleQuery1();
      }
    },

    clearState() {
      this.resetForm('ruleForm')
      this.ruleForm = this.$until.easyDeepCopy(this.ruleFormTep)
      this.centerDialogVisible = false;
      this.handleQuery();
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}
</style>
